import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import Swal from 'sweetalert2';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-auditor-report',
  templateUrl: './auditor-report.component.html',
  styleUrls: ['./auditor-report.component.css']
})
export class AuditorReportComponent implements OnInit {

  admin_data: any;
  displayList: boolean = true;
  displayPdf: boolean = false;
  fiscal_year: any;
  pdfSrc: any;
  data_report = [] as any;
  years = [] as any;
  year_select = '';
  data_select = [] as any;
  uploadForm!: FormGroup;
  file!: string;
  data_file: string[] = [];
  filedata!: string
  pdfName: any;
  page = 1;
  count = 0;
  tableSize = 15;

  constructor(
    public services: ApiService,
    public formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    document.getElementById('auditorreport')!.classList.toggle("active");

    this.admin_data = localStorage.getItem("admin_data");
    this.admin_data = JSON.parse(this.admin_data);
    this.fiscal_year = this.services.fiscal_year;
    this.getDataAll();
    this.uploadForm = this.formBuilder.group({
      pdf_file: '',
      type: 'auditor_report',
      year: '',
      user_id: parseInt(this.admin_data.id),
      status: 'Enable',
      pdf_name: ''
    });
  }

  ngOnDestroy(){
    document.getElementById('auditorreport')!.classList.remove("active");
  }

  getDataAll() {
    this.services.getByType('auditor_report').then((res: any) => {
      this.getReport(res);
    })
  }
  getReport(data: any) {
    let year = [] as any;
    let report = [] as any
    data.forEach((file: any) => {
      if (file.status == 'Enable') {
        report.push(file)
      }
    });
    this.data_report = report.sort((a: any, b: any) => (a.year > b.year) ? -1 : ((b.year > a.year) ? 1 : 0))
    this.data_report.forEach((data: any) => {
      data.year = parseInt(data.year)
      data.date_report = this.dateThaiFormat(data.date_report);
      this.data_select.push(data);
      year.push(data.year);
    });
    this.years = [...new Set(year)].sort();
  }
  selectYear() {
    this.data_select = [];
    this.data_report.forEach((data: any) => {
      if (this.year_select == data.year) {
        this.data_select.push(data);
      }
    });
  }

  onClickDownload(file_name: any, name: any) {
    this.pdfSrc = "https://ogc.mapedia.co.th/api/v1/lrfund/m_file/" + file_name;
    FileSaver.saveAs(this.pdfSrc, name);
  }
  onClickView(file_name: any, name: any) {
    this.displayList = false;
    this.displayPdf = true;
    this.pdfName = name;
    this.pdfSrc = "https://ogc.mapedia.co.th/api/v1/lrfund/m_file/" + file_name;
  }
  onClickDelete(data: any) {
    data.status = 'Disable';
    Swal.fire({
      title: 'ยืนยันการลบ',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.services.update('m_pdffile', parseInt(data.id), data).then((res: any) => {
          Swal.fire({
            title: 'ลบไฟล์สำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          }).then((res) => {
            this.data_report = [];
            this.data_select = [];
            this.getDataAll();
          })
        })
      }
    })
  }
  onClickClose() {
    this.displayList = true;
    this.displayPdf = false;
  }
  onFileSelect(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.file = event.target.files[0];
      this.data_file.push(event.target.files[0]);
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.filedata = reader.result as string;
        this.uploadForm.patchValue({
          fileSource: reader.result
        });
      };
    }
  }
  onClickSave() {
    const formData = new FormData();
    formData.append('pdf_file', this.data_file[0]);
    formData.append('type', this.uploadForm.get('type')!.value);
    formData.append('year', this.uploadForm.get('year')!.value);
    formData.append('user_id', this.uploadForm.get('user_id')!.value);
    formData.append('status', this.uploadForm.get('status')!.value);
    formData.append('pdf_name', this.uploadForm.get('pdf_name')!.value);

    this.services.uploadFile('m_pdffile', formData).then(res => {
      Swal.fire({
        title: 'อัพโหลดไฟล์สำเร็จ',
        icon: 'success',
        confirmButtonText: `ตกลง`
      });
      this.data_select = [];
      this.getDataAll();
      this.file = ''
      this.data_file= []
      this.filedata= ''
      this.uploadForm = this.formBuilder.group({
        pdf_file: [''],
        type: ['auditor_report'],
        year: [''],
        user_id: parseInt(this.admin_data.id),
        status: ['Enable'],
        pdf_name: ''
      });
    });
  }
  onClose(){
    this.uploadForm = this.formBuilder.group({
      pdf_file: [''],
      type: ['auditor_report'],
      year: [''],
      user_id: [0],
      status: ['Enable']
    });
  }

  dateThaiFormat(date: any) {
    return date = new Date(date).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
  onTableDataChange(event: any) {
    this.page = event;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }

}
